import {css} from 'linaria'

const borderColor = "#E3E3E3";
export const breakpointSmall  = '@media all and (min-width: 60em)'
export const breakpointMedium = '@media all and (min-width: 80em)'
export const breakpointLarge  = '@media all and (min-width: 120em)'

const clearfix = {
  content: "",
  display: 'table',
  clear: 'both'
}

const truncate = {
  "text-overflow": "ellipsis",
  "white-space": "nowrap",
  "overflow": "hidden"
}

export const border = css``
export const borderStriped = css``
export const grid = css``
export const striped = css``
export const tableContentColumn = css``
export const force = css``
export const middle = css``
export const middleLeft = css``
export const middleRight = css``
export const leftMiddle = css``
export const top = css``
export const bottom = css``
export const offset = css``
export const gutter = css``
export const gutterForce = css``
export const clickable = css``
export const tableRow = css``
export const insetBreak = css``

export const container = css`
  height: 100%;
  max-width: 100em;
  margin: 0 auto;
  padding: 0;
  ${breakpointSmall} {
    padding: 0 2em;
  };
  ${breakpointMedium} {
    padding: 0 3em;
  };
  ${breakpointLarge} {
    padding: 0 4em;
  };
`

export const inset = css`
  padding-left: 1.7em;
  padding-right: 1.7em;
  &.${insetBreak} {
    ${breakpointSmall} {
      padding-left: 0;
      padding-right: 0;
    }
  }
`

export const row = css`
  display: block;
  ${breakpointSmall} {
    display: table !important;
    table-layout: fixed;
  };
  width: 100%;
  padding: 0;
  &:after {
    ${clearfix};
  }
  &.${border} {
    border-top: 1px solid ${borderColor};
    border-bottom: 1px solid ${borderColor};
  }
  &.${borderStriped} {
    border-bottom: 1px solid ${borderColor};
    &:last-child {
      border-bottom: inherit;
    }
  }

  &.${grid} {
    width: auto;

    ${breakpointSmall} {
      margin-left: -1.7em;
      margin-right: -1.7em;
    };
  }
`

export const tableHeader = css`
  &.${tableRow} {
    border-top: 1px solid ${borderColor};
    border-bottom: 1px solid ${borderColor};
    text-transform: uppercase;
    background-color: #E3E3E3;
    color: #3C3C3B;
    font-weight: bold;
    display: none;
    ${breakpointSmall} {
      display: block;
    };
  }
`

export const tableContent = css`
  &.${tableRow} {
    border-bottom: 1px solid ${borderColor};
    &.${striped}:nth-child(even) {
      background-color: #F9F9F9;
    }
    &:hover {
      background-color: #CEE9FB !important;
    }
    .${tableContentColumn} {
      border-bottom: 1px solid ${borderColor};
      word-wrap: break-word;
      ${breakpointSmall} {
        border-bottom: inherit;
      };
    }
  }
`

export const header = css`
  :before {
    color: #707070;
    width: 50%;
    display: inline-block;
    text-transform: uppercase;
    vertical-align: top;
    font-weight: bold;
    ${truncate};
    ${breakpointSmall} {
      display: none;
    };
  }

  color: #707070;
  font-size: 0.9em;
`
export const tableFooter = css`
  &.${tableRow} {
    background-color: #F0F0F0;
    color: #3C3C3B;
  }
`

const columnBase = {
  "display": "inline-block",
  "vertical-align": "top",
  [breakpointSmall]: {
    "display": "table-cell",
    "vertical-align": "middle"
  },
  "height": "100%",
  "width": "100%",
  "padding": "0.5em 0",
  [`&.${middle}`]: {
    // center a column vertically and horizontally
    "vertical-align": "middle",
    "text-align": "center",
    // revert to horizontal left (but keep vertical center)
    [`&.${middleLeft}`]: {
      [`&.${force}`]: {
        "text-align": "left"
      },
      [breakpointSmall]: {
        "text-align": "left"
      }
    },
    // revert to horizontal right (but keep vertical center)
    [`&.${middleRight}`]: {
      [`&.${force}`]: {
        "text-align": "right"
      },
      [breakpointSmall]: {
        "text-align": "right"
      }
    },
    // the content will lose its center alignment and be made left aligned on small devices
    [`&.${leftMiddle}`]: {
      "text-align": "left",
      [breakpointSmall]: {
        "text-align": "center"
      }
    }
  },
  [`&.${top}`]: {
    "vertical-align": "top"
  },
  [`&.${bottom}`]: {
    "vertical-align": "bottom"
  },
  [`&.${border}`]: {
    "border-left": `1px solid ${borderColor}`,
    "border-top": `1px solid ${borderColor}`,
    "border-bottom": `1px solid ${borderColor}`,
    [`&:last-child`]: {
      "border-right": `1px solid ${borderColor}`
    }
  },
  [`&.${borderStriped}`]: {
    // stripes are only shown when the real columns are activated
    "border-right": "inherit",
    [`&.${force}`]: {
      "border-right": `1px solid ${borderColor}`
    },
    [breakpointSmall]: {
      "border-right": `1px solid ${borderColor}`,
      [`&:last-child`]: {
        "border-right": "inherit"
      }
    }
  },
  [`&.${offset}`]: {
    "display": "none",
    [`${breakpointSmall}`]: {
      "display": "table-cell",
      [`&.${force}`]: {
        "display": "inline-block"
      }
    }
  },
  [`&.${gutter}`]: {
    [`&.${force}`]: {
      "padding-left": "1em",
    },
    [breakpointSmall]: {
      "padding-left": "1em",
      [`&.${gutterForce}`]: {
        "padding-left": "1em !important",
      }
    }
  },
  [`&.${clickable}`]: {
    "cursor": "pointer",
  }
}

export const columnVariableRefundable = css`
  padding-top: 0;
`
export const columnCrossBorderCountryConfiguration = css`
  padding-top: 0;
`


export const column100 = css`
  ${columnBase};
  &.${force} { width: 100%; }
  ${breakpointSmall} { width: 100%; }
`
export const column95 = css`
  ${columnBase};
  &.${force} { width: 95%; }
  ${breakpointSmall} { width: 95%; }
`
export const column90 = css`
  ${columnBase};
  &.${force} { width: 90%; }
  ${breakpointSmall} { width: 90%; }
`
export const column85 = css`
  ${columnBase};
  &.${force} { width: 85%; }
  ${breakpointSmall} { width: 85%; }
`
export const column80 = css`
  ${columnBase};
  &.${force} { width: 80%; }
  ${breakpointSmall} { width: 80%; }
`
export const column75 = css`
  ${columnBase};
  &.${force} { width: 75%; }
  ${breakpointSmall} { width: 75%; }
`
export const column70 = css`
  ${columnBase};
  &.${force} { width: 70%; }
  ${breakpointSmall} { width: 70%; }
`
export const column66 = css`
  ${columnBase};
  &.${force} { width: 66.66%; }
  ${breakpointSmall} { width: 66.66%; }
`
export const column65 = css`
  ${columnBase};
  &.${force} { width: 65%; }
  ${breakpointSmall} { width: 65%; }
`
export const column60 = css`
  ${columnBase};
  &.${force} { width: 60%; }
  ${breakpointSmall} { width: 60%; }
`
export const column55 = css`
  ${columnBase};
  &.${force} { width: 55%; }
  ${breakpointSmall} { width: 55%; }
`
export const column50 = css`
  ${columnBase};
  &.${force} { width: 50%; }
  ${breakpointSmall} { width: 50%; }
`
export const column45 = css`
  ${columnBase};
  &.${force} { width: 45%; }
  ${breakpointSmall} { width: 45%; }
`
export const column40 = css`
  ${columnBase};
  &.${force} { width: 40%; }
  ${breakpointSmall} { width: 40%; }
`
export const column35 = css`
  ${columnBase};
  &.${force} { width: 35%; }
  ${breakpointSmall} { width: 35%; }
`
export const column33 = css`
  ${columnBase};
  &.${force} { width: 33.33%; }
  ${breakpointSmall} { width: 33.33%; }
`
export const column30 = css`
  ${columnBase};
  &.${force} { width: 30%; }
  ${breakpointSmall} { width: 30%; }
`
export const column25 = css`
  ${columnBase};
  &.${force} { width: 25%; }
  ${breakpointSmall} { width: 25%; }
`
export const column20 = css`
  ${columnBase};
  &.${force} { width: 20%; }
  ${breakpointSmall} { width: 20%; }
`
export const column16 = css`
  ${columnBase};
  &.${force} { width: 16.66%; }
  ${breakpointSmall} { width: 16.66%; }
`
export const column15 = css`
  ${columnBase};
  &.${force} { width: 15%; }
  ${breakpointSmall} { width: 15%; }
`
export const column10 = css`
  ${columnBase};
  &.${force} { width: 10%; }
  ${breakpointSmall} { width: 10%; }
`
export const column5  = css`
  ${columnBase};
  &.${force} { width: 5%; }
  ${breakpointSmall} { width: 5%; }
`
export const column2  = css`
  ${columnBase};
  &.${force} { width: 2%; }
  ${breakpointSmall} { width: 2%; }
`
export const column1  = css`
  ${columnBase};
  &.${force} { width: 1%; }
  ${breakpointSmall} { width: 1%; }
`
export const columnAuto  = css`
  ${columnBase};
  &.${force} { width: auto; }
`

// convert all icons to base64 and use them as data uri's
// this means all icons can be downloaded with only one request
// instead of a separate request for each icon

// To convert to an image to base64 run this command
//
//     cat path/to/file.png | openssl base64 | tr -d '\n' | pbcopy
//
// This copies the base64 string into your copy buffer
// And then you can paste it into the target file

// Make sure the raw file is included in the /asset folder for future reference

const icon = `
  display: inline-block;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  vertical-align: middle;
`

export const input = css`
    // for displaying in an input
    width: 100% !important;
    height: auto !important; // PAYL-2513, PAYL-2513 use "auto" instead of "initial", as IE doesn't support "initial"
`

export const iconEnvelope = css`
  ${icon};
  width: 1.7em;
  height: 1.7em;
  &.${input} {
    background-size: 1.4em;
    background-position: 1em;
    padding-left: 3.3em;
  }
  background-image: url(data:image/svg+xml;base64,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);
`
export const iconLock = css`
  ${icon};
  width: 1.3em;
  height: 1.3em;
  &.${input} {
    background-size: 1.15em;
    background-position: 1.2em;
    padding-left: 3.3em;
  }
  background-image: url(data:image/svg+xml;base64,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);
`
export const iconTick = css`
  ${icon};
  width: 1.4em;
  height: 1.4em;
  background-image: url(data:image/svg+xml;base64,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);
`

export const iconDownload = css `
  ${icon};
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEDSURBVHgB7ZeNDYIwEIWfPwM4Ak6gG8AIbuBtwo3GBsYJHEVrQsNfhRpCr23uS17SBI57r4XkABRFUXKlMHq1OiFBbkbvVoSN2GM7guz6lgGCoAGk0QDSaABpNIA0awPUraTqV/FtbGcdlwnC/Cy0VO/FmhPY9db8p4m6rXE9KyiMbhfHO0lwn0A9qmEIw3CHIEwDRGfewpiGIAwDRGvewhgafPxYR2newhgadYkROYyEzVsYCZu3MBI2b7kaVVAy5rBwnYwuRk/IQGv6E7qP8I7wkE//uWm06K3PCE8Bj/76SymNBpDm6HlfifDjQOlzk2+ACpGOBFm/Qg3ioYGiKHnyAWwWYGA3r2GAAAAAAElFTkSuQmCC);
`

export const iconError = css`
  ${icon};
  width: 2.7em;
  height: 2.7em;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAT2SURBVHgB7ZzBbttGEIZnl1RRtAigU4HkUvmSS91alpVzlZ4DJO0L2A2Qs+28QOwniNMXiP0EbQDfo9zF2E7aSy5SL84xBIIWRURxOkOTikgvRUoiRUnc72BSJAWZP2ZnZpczFDBHzur1aqVSqaHr/kgf16QQ3wJinc+hELXRawVij47ZtGsj4gVtuyDExfedThvmiICcYVFMw9gWQjygG63Ttgqz0yZhj/uDwavN8/Me5EguAo2KQh9bkC+eWOuWdQI5kKlALMwXprnrIu5lZCnpoSFJv3n8yXFOsrSqTAQqVJgovlDfdTqHkAEzC/S22WyRQ30OESdbOFdO/tdZnfrUAnkRyTSf0O4eLDZHfcc5pGFnwxRMJRCJU6sYxsuFs5o4yJoo4t2dxjdJmBAeUhShzpZGHIb+V7L2szdbWw8m/OZkAr29c2eXTO5l4Y54OqqUmP7+Z7M5kUtILdBfzeYTcsZHsPw85XtJe3EqH+RZzmqIM8r+eqeTeE+JAvG4ZdOEFQQB7ialAWMF4mjFDnlJfU4abEoBNsdFt1iBvDxnDtGqeu8efLW1pTz3r2WBfXoKuXKVAmzG5Ulm3Pf8JLAGOfM1icMixZG7QFcpAN/rvuq0Mor5+cKiZ8hZssf5neqEjDn4FEoGzyfZrUSPXxPIyxGWKUvOCrpn0zSvjZqQQBy1aNVvB0oKRazdqBWFBKI1ne1SWs9nqlErCglUZusJiFrRUKA3jcZOya0ngNe5doIPQ4GklNugCbgf7HgCsXOG/J8+LBOtYJh5AhlStkATIhhmnkB6eCnxhlngg1qgiVLnYSbj5iAa8OoIpEtKgUYNYktKxBpo1JA2tJoqNkCjhEty2Emv6nLqzNASyIakP1qgMUjU8694/CGmGYMWKAEtUALspHugUUPaaAsahxA2TzXOQROHzRb0N2jUIF5IV4geaNSQNoLWPOpcngYF8eXt22DcuKE89+nyEvrv30NRcHkMFy/0aMcWBc3J/nv3DhYVrh2SXPYhtKNW0eY/XpgfALwATRjEY954ArmOcwyaENxJxFtPIL+6qg2agHZQljfMpPUwG8EfXsywRtHr8TLN7ryjWeXWLajcvKk85378OP8oR/OvdctaCz4OaxR5mNEjoGe0m7rIOgu+efQotkbxw+kpXB5m0tWUGlpADDXmhSarjuMccU4EZYWsx4kErJBAvrN+BiWFrSdaM31tuYOtCMq4RoTYpcz5IHr4mkBsRdypByWD7vmh6rhywYznIIhYnqGGeBTXsxFbae8MBgcVw7ifd1neP5bFs2Yl3IqQN2QIXbrX2FCZ3MxCSyFiRZ++kjgfSJzGuGaWsWvS/hd/htUEyXIfJvWxJi7a89gcuO4+rB6Pf7CsP5IuSvVUY+P1a04g55vS5gdbzmGabkNmorbwi0Zjz5BymRtdOB48TisOM3HfPLdKCSGeL5vjZodMEfmXSd/EUJYXC3RpAeynubxYgOEf4jbGJUgmkZPAfkIoH8fMLzfxuqK5AW/xXm7S5elDYS83iUJrSQcCsfB2Kt/X/MaT7mlfaDJKZgIxfua9U4BQpAvaWQoTkKlAo3B7ld/i0IJ8CKZwPLF+QVOGkyyFCchNoAC2Km6WyUAsTxC2FEozzvMUZZTcBYritT4gcm32ml+jXeVKW9VrAmmDLolB13MFSs+R8hX0+728RRnlfweUHYjDyv+KAAAAAElFTkSuQmCC);
`

export const iconHouse = css`
  ${icon};
  width: 1.7em;
  height: 1.7em;
  &.${input} {
    background-size: 1.4em;
    background-position: 1.1em;
    padding-left: 3.3em;
  }
  background-image: url(data:image/svg+xml;base64,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);
`

export const iconAlert = css`
  ${icon};
  width: 1.7em;
  height: 1.7em;
  &.${input} {
    background-size: 1.4em;
    background-position: 1.1em;
    padding-left: 3.3em;
  }
  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjVweCIgaGVpZ2h0PSIyNXB4IiB2aWV3Qm94PSIwIDAgMjUgMjUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+R3JvdXA8L3RpdGxlPgogICAgPGcgaWQ9IlN1bW1hcmlzZWQtZmxvd3MtJmFtcDstZGlhZ3JhbXMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJBcnRib2FyZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE0Ni4wMDAwMDAsIC0xMjQuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQ2LjAwMDAwMCwgMTI0LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbCIgZmlsbD0iI0NDMDAwMCIgY3g9IjEyLjUiIGN5PSIxMi41IiByPSIxMi41Ij48L2NpcmNsZT4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMy43OTkxMjY5LDE0LjkzNTg2MyBMMTQuMzMzNDQ1Myw0LjcgTDEwLjcwODQ2MjEsNC43IEwxMS4yNDI3ODA0LDE0LjkzNTg2MyBMMTMuNzk5MTI2OSwxNC45MzU4NjMgWiBNMTIuNTEwNDc2OCwyMC4zIEMxMy4wODMyMTAyLDIwLjMgMTMuNTMwMjIxNiwyMC4xNDExMDE0IDEzLjg1MTUxMTEsMTkuODIzMzA0MiBDMTQuMTcyODAwNSwxOS41MDU1MDcxIDE0LjMzMzQ0NTMsMTkuMDcwNzE4NiAxNC4zMzM0NDUzLDE4LjUxODkzODkgQzE0LjMzMzQ0NTMsMTcuOTQ2MjA1NSAxNC4xNzQ1NDY3LDE3LjUwNjE3ODYgMTMuODU2NzQ5NSwxNy4xOTg4NTgzIEMxMy41Mzg5NTIzLDE2Ljg5MTUzNzkgMTMuMDkwMTk0OCwxNi43Mzc4Nzc4IDEyLjUxMDQ3NjgsMTYuNzM3ODc3OCBDMTEuOTA5ODA1MiwxNi43Mzc4Nzc4IDExLjQ1MjMxNywxNi44ODgwNDU3IDExLjEzODAxMjEsMTcuMTg4MzgxNSBDMTAuODIzNzA3MiwxNy40ODg3MTczIDEwLjY2NjU1NDcsMTcuOTMyMjM2NCAxMC42NjY1NTQ3LDE4LjUxODkzODkgQzEwLjY2NjU1NDcsMTkuMDg0Njg3NyAxMC44MjcxOTk1LDE5LjUyMjk2ODQgMTEuMTQ4NDg4OSwxOS44MzM3ODExIEMxMS40Njk3Nzg0LDIwLjE0NDU5MzcgMTEuOTIzNzc0MywyMC4zIDEyLjUxMDQ3NjgsMjAuMyBaIiBpZD0iISIgZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJub256ZXJvIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==);

`

export const iconAlertInfo = css`
  ${icon};
  width: 1.7em;
  height: 1.7em;
  background-image: url(data:image/svg+xml;base64,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);
`

export const iconChevronRight = css`
  ${icon};
  width: 1em;
  height: 1em;
  &.${input} {
    background-size: 1.4em;
    background-position: 1.1em;
    padding-left: 3.3em;
  }
  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNnB4IiBoZWlnaHQ9IjExcHgiIHZpZXdCb3g9IjAgMCA2IDExIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHRpdGxlPlBhdGggMiBDb3B5IDI8L3RpdGxlPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkFydGJvYXJkLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMjEuMDAwMDAwLCAtNDEwLjAwMDAwMCkiIHN0cm9rZT0iIzJEMzEzNCI+CiAgICAgICAgICAgIDxwb2x5bGluZSBpZD0iUGF0aC0yLUNvcHktMiIgcG9pbnRzPSIzMjEuNSA0MTAuNDA0NDc4IDMyNi41IDQxNS40MDQ0NzggMzIxLjUgNDIwLjQwNDQ3OCI+PC9wb2x5bGluZT4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==);
`
